import {createSlice, current} from "@reduxjs/toolkit";
import {produce} from "immer";

const initialState = {
    action: false,
    open: false,
    message: 'Note archived',
    anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right'
    },
    variant: 'default',
    alert: {
        color: 'primary',
        variant: 'filled'
    },
    transition: 'Fade',
    close: true,
    maxStack: 3,
    dense: false,
    iconVariant: 'hide',
    actionButton: false
};

export const snackbarSlice = createSlice({
    name: 'snackbar',
    initialState: initialState,
    reducers: {
        openSnackbar(state, action) {
            const { open, message, anchorOrigin, variant, alert, transition, close, actionButton } = action.payload;
            return produce(current(state), draft => {
                draft.action = !state.action;
                draft.open = open || initialState.open;
                draft.message = message || initialState.message;
                draft.anchorOrigin = anchorOrigin || initialState.anchorOrigin;
                draft.variant = variant || initialState.variant;
                draft.alert = {
                    color: alert?.color || initialState.alert.color,
                    variant: alert?.variant || initialState.alert.variant
                };
                draft.transition = transition || initialState.transition;
                draft.close = close === false ? close : initialState.close;
                draft.actionButton = actionButton || initialState.actionButton;
            })

        },

        closeSnackbar(state) {
            return produce(current(state), draft => {
                draft.open = false;
            })
        },

        handlerDense(state, action) {
            const { dense } = action.payload;
            return produce(current(state), draft => {
                draft.dense = dense;
            })

        },

        handlerIncrease(state, action) {
            const { maxStack } = action.payload;
            return produce(current(state), draft => {
                draft.maxStack = maxStack;
            })
        },

        handlerIconVariants(state, action) {
            const { iconVariant } = action.payload;
            return produce(current(state), draft => {
                draft.iconVariant = iconVariant;
            })
        }
    }
});

export const {
    closeSnackbar,
    openSnackbar,
    handlerDense,
    handlerIconVariants,
    handlerIncrease
} = snackbarSlice.actions;


export default snackbarSlice.reducer